import {MAT_SNACK_BAR_DATA, MatSnackBarRef} from '@angular/material/snack-bar';
import {Component, Inject, inject} from '@angular/core';

@Component({
  selector: 'snackbar-custom',
  templateUrl: 'snackbar.components.html',
  styles: [
    `
      :host {
        display: flex;
      }

      .example-pizza-party {
        color: hotpink;
      }
    `,
  ],
})
export class SnackbarComponent {
  image;
  success = '/assets/images/success.gif';
  error = '/assets/images/error.gif';
  snackBarRef = inject(MatSnackBarRef);
  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: any) {
    if (data.type == 'success') {
      this.image = this.success;
    } else if (data.type == 'error') {
      this.image = this.error;
    }
  }
}
